// extracted by mini-css-extract-plugin
module.exports =  {"underground-icon":"_93444fe79c--underground-icon--LHNp0","underground-icon--regions":"_93444fe79c--underground-icon--regions--VPxpC"};